import React from 'react'
import { Link } from 'react-router-dom'
import { MODELLO_ORGANIZZATIVO_DI_GESTIONE_E_CONTROLLO } from '../../constants'

const FirstSection = () => {
  return (
    <>
      <div className='mt-12 container mx-auto text-lg text-blue-text text-cls '>
        <p data-aos="fade-right">
          Il <b>Centro di Riabilitazione Neuromotoria Papa Giovanni XXIII</b> offre gestione efficiente e trattamenti all'avanguardia. 
          È specializzato nella riabilitazione di patologie acute e degenerative del sistema nervoso centrale e periferico, come 
          ictus, sindrome di Guillain-Barré e morbo di Parkinson, oltre a traumi encefalici e problemi vascolari periferici. Si 
          occupa anche di riabilitazione ortopedica post-operatoria e post-frattura. Utilizza terapie innovative, tra cui la tossina 
          botulinica per la spasticità, grazie a un'équipe dedicata a ricerca e innovazione.
        </p>
      </div>

      
    <div className='mt-12 container mx-auto flex flex-col lg:flex-row gap-7 lg:gap-0 stretch justify-between font-semibold pb-12 lg:pb-20 border-b-2 border-blue-secondary'>
      <div data-aos="fade-right" className='lg:w-[28%] flex flex-col justify-center'>
        <Link to={MODELLO_ORGANIZZATIVO_DI_GESTIONE_E_CONTROLLO}
          className='flex flex-col justify-center items-center flex-grow  bg-blue-primary py-2 px-2 w-full text-center'
        >
          <p className='leading-[1.5] w-full mx-auto text-white text-lg'>
            MODELLO ORGANIZZATIVO <br className='hidden lg:block' />
            DI GESTIONE E CONTROLLO
          </p>
        </Link>
      </div>

      <div data-aos="fade-left" className='lg:w-[28%] flex flex-col justify-center'>
        <a
          href="/amministrazione-trasparente"
          className='flex flex-col justify-center items-center flex-grow  bg-blue-primary py-2 px-2 w-full text-center'
        >
          <p className='leading-[1.5] w-full mx-auto text-white text-lg'>
            AMMINISTRAZIONE TRASPARENTE
          </p>

        </a>

      </div>

      <div data-aos="fade-left" className='lg:w-[28%] flex flex-col justify-center'>
        <a
          href="/whistleblowing"
          className='flex flex-col justify-center items-center flex-grow  bg-blue-primary py-2 px-2 w-full text-center'
        >
          <p className='leading-[1.5] w-full mx-auto text-white text-lg'>
            WHISTLEBLOWING
          </p>

        </a>
        {/* <img className='w-full' src="/images/shadow.png" /> */}
      </div>
    </div>
    </>
  )
}

export default FirstSection